<template>
	<div class="flex flex-col">
		<transition name="fade" mode="out-in">
			<div class="relative p-4 sm:p-6">
				<div
					v-if="Object.keys(errors).length"
					class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded"
				>
					<p v-for="(error, key) in errors" :key="key">{{ error }}</p>
				</div>
				<router-view />
			</div>
		</transition>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: 'CoverDetailsPage',
	computed: {
		...mapState('insurance/motorPrivate', ['errors']),
	},
	methods: {
		...mapActions('insurance/motorPrivate', ['clearErrors']),
	},
	mounted() {
		this.clearErrors();
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
